// BAG CRAP: say why a card "+ Add" didn't add (Oct 18, 2026).
// Most pieces are one of a kind. When the shopper already has every one in stock in their bag,
// Shopify refuses the add ("The maximum quantity of this item is already in your cart.") and the
// cards used to just reopen the bag with no message. This watches card adds (main.js) and, when
// refused, flashes the card button and puts a short note at the top of the bag.
// Collection pages: bag-bar.js reads window.bcAddRefused and shows the note in the bar instead.
// Product page adds are handled by pdp-add-feedback.js.
(function () {
  if (window.__bcAddFeedback || typeof window.fetch !== "function") return;
  window.__bcAddFeedback = true;

  var MSG = "Already in your bag — that's all we've got.";
  var SOLD = "Sorry, that one just sold out.";
  var lastBtn = null;
  var lastTap = 0;

  document.addEventListener("click", function (event) {
    var btn = event.target.closest && event.target.closest(".plp-atc-btn");
    if (btn) { lastBtn = btn; lastTap = Date.now(); }
  }, true);

  // The theme hides plain button text (span:not([style])), so the label carries an inline style.
  function flash(btn, text) {
    if (!btn) return;
    // If bag-bar.js is still showing "✓ Added", restore to the real "+ Add" label, not that.
    if (!btn.dataset.afIcon) btn.dataset.afIcon = btn.dataset.bbIcon || btn.innerHTML;
    clearTimeout(btn._bbT);
    btn.innerHTML = '<span style="font-size:11px;letter-spacing:.5px;white-space:nowrap;font-family:Parkinsans,sans-serif;font-weight:800;text-transform:uppercase;color:#fff;opacity:1;animation:none;">' + text + "</span>";
    clearTimeout(btn._afT);
    btn._afT = setTimeout(function () {
      btn.innerHTML = btn.dataset.afIcon;
      delete btn.dataset.afIcon;
    }, 2500);
  }

  function bagNotice(text) {
    var middle = document.querySelector("#side-cart .middle");
    if (!middle) return;
    var note = document.getElementById("bc-add-notice");
    if (!note) {
      note = document.createElement("div");
      note.id = "bc-add-notice";
      note.setAttribute("role", "status");
      note.style.cssText = "margin:10px 12px 0;padding:10px 12px;background:#FFE9FB;color:#4D04AD;font-family:Parkinsans,sans-serif;font-weight:800;font-size:12px;text-transform:uppercase;text-align:center;border-radius:6px;";
      middle.insertBefore(note, middle.firstChild);
    }
    note.textContent = text;
    note.hidden = false;
    clearTimeout(note._t);
    note._t = setTimeout(function () { note.hidden = true; }, 6000);
  }

  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var request = origFetch.apply(this, arguments);
    try {
      var url = typeof input === "string" ? input : (input && input.url) || "";
      var isCardAdd = /\/cart\/add(\.js)?(\?|$)/.test(url) && init && typeof init.body === "string" &&
        lastBtn && Date.now() - lastTap < 4000;
      if (isCardAdd) {
        var btn = lastBtn;
        request.then(function (response) {
          if (response.status !== 422) return;
          // Set right away: main.js opens the bag after this, and bag-bar.js checks it then.
          window.bcAddRefused = { t: Date.now(), text: "Already in your bag" };
          response.clone().json().then(function (data) {
            var said = (data && (data.description || data.message)) || "";
            var sold = /sold out/i.test(said);
            if (sold && window.bcAddRefused) window.bcAddRefused.text = "Just sold out";
            flash(btn, sold ? "Sold out" : "In your bag");
            bagNotice(sold ? SOLD : MSG);
          }, function () {
            flash(btn, "In your bag");
            bagNotice(MSG);
          });
        }, function () {});
      }
    } catch (error) {
      // never get in the way of an add to bag
    }
    return request;
  };
})();
